import { useEffect } from 'react';

const SUFFIX = 'DiveLogApp';

/**
 * Sets document.title to `<title> · DiveLogApp` on mount + on changes,
 * restores the previous title on unmount.
 */
export function useDocumentTitle(title: string | undefined | null): void {
  useEffect(() => {
    if (!title) return;
    const prev = document.title;
    document.title = `${title} · ${SUFFIX}`;
    return () => { document.title = prev; };
  }, [title]);
}
